import angular from 'angular';
import uiRouter from 'angular-ui-router';
import MainComponent from './main.component';
import routing from './main.routes';

export default angular
  .module('verifyApp.main', [uiRouter])
  .config(routing)
  .component('main', MainComponent)
  .name;



// WEBPACK FOOTER //
// ./client/app/main/index.js